module.exports = __webpack_public_path__ + "img/big_1_5.356853f7.png";